import OIntegrationCloseButton from './o-integration-close-button';

export default OIntegrationCloseButton;